import React, { useEffect, useRef } from 'react';

/**
 * Same purpose of useEffect but it doesn't run on the first render
 *
 * @param effect — Imperative function that can return a cleanup function
 * @param deps — If present, effect will only activate if the values in the list change.
 */

export default function useDidUpdateEffect(
  effect: React.EffectCallback,
  deps?: React.DependencyList
) {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      effect();
    } else {
      didMountRef.current = true;
    }
  }, deps);
}
